/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NextechResultMessage = {
    readonly id?: number;
    status?: NextechResultMessage.status;
    /**
     * Optional reason for error status
     */
    error_reason?: string | null;
    readonly created_at?: string;
}

export namespace NextechResultMessage {

    export enum status {
        PENDING = 'pending',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
        DROPPED = 'dropped',
    }


}
